import { Button } from "@mui/material";

export default function DinamicButton({ fontSize = "11px", type = "button", backgroundColor = "#ff6400", hoverBackgroundColor = "#bb4a03", width = "230px", content, action, icon = null, iconSize = 20, disabled = false }) {
  return (
    <Button
      variant="contained"
      endIcon={icon}
      type={type}
      sx={{
        fontSize: "11px",
        fontWeight: "bold", 
        fontFamily: "poppins",
        padding: "4px 16px",
        backgroundColor: backgroundColor,
        transform: "all",
        animationDuration: "1000",
        textTransform: "none",
        borderRadius: "8px",
        width: width,
        '& .MuiButton-endIcon > *:nth-of-type(1)': {
          fontSize: iconSize,
        },
        '&:hover': {
          backgroundColor: hoverBackgroundColor,
        }
      }}
      onClick={action}
      disabled={disabled}
    >
      {content}
    </Button>
  )
}
